const visaOfficeValues = [
  {
    text: "Afghanistan, Islamic Republic of - Austrian Embassy Islamabad",
    value: "Afghanistan, Islamic Republic of; Austrian Embassy Islamabad",
  },
  {
    text: "Albania, Republic of - Austrian Embassy Tirana",
    value: "Albania, Republic of; Austrian Embassy Tirana",
  },
  {
    text: "Algeria, People's Democratic Republic of - Austrian Embassy Algier",
    value: "Algeria, People's Democratic Republic of; Austrian Embassy Algier",
  },
  {
    text: "Algeria, People's Democratic Republic of - VFS Algier",
    value: "Algeria, People's Democratic Republic of; VFS Algier",
  },
  {
    text: "Algeria, People's Democratic Republic of - VFS Oran",
    value: "Algeria, People's Democratic Republic of; VFS Oran",
  },
  {
    text: "Andorra, Principality of - Spanish Embassy Andorra",
    value: "Andorra, Principality of; Spanish Embassy Andorra",
  },
  {
    text: "Angola, Republic of - Austrian Embassy Pretoria",
    value: "Angola, Republic of; Austrian Embassy Pretoria",
  },
  {
    text: "Angola, Republic of - Portuguese Embassy Luanda",
    value: "Angola, Republic of; Portuguese Embassy Luanda",
  },
  {
    text: "Antigua and Barbuda - Austrian Embassy Havanna",
    value: "Antigua and Barbuda; Austrian Embassy Havanna",
  },
  {
    text: "Argentinia (Argentine Republic) - Austrian Embassy Buenos Aires",
    value: "Argentinia (Argentine Republic); Austrian Embassy Buenos Aires",
  },
  {
    text: "Armenia, Republic of - Austrian Embassy Tiflis",
    value: "Armenia, Republic of; Austrian Embassy Tiflis",
  },
  {
    text: "Armenia, Republic of - VFS Jerewan",
    value: "Armenia, Republic of; VFS Jerewan",
  },
  {
    text: "Australia - Austrian Embassy Canberra",
    value: "Australia; Austrian Embassy Canberra",
  },
  { text: "Australia - VFS Adelaide", value: "Australia; VFS Adelaide" },
  { text: "Australia - VFS Brisbane", value: "Australia; VFS Brisbane" },
  { text: "Australia - VFS Canberra", value: "Australia; VFS Canberra" },
  { text: "Australia - VFS Melbourne", value: "Australia; VFS Melbourne" },
  { text: "Australia - VFS Perth", value: "Australia; VFS Perth" },
  { text: "Australia - VFS Sydney", value: "Australia; VFS Sydney" },
  {
    text: "Azerbaijan, Republic of - Austrian Embassy Baku",
    value: "Azerbaijan, Republic of; Austrian Embassy Baku",
  },
  {
    text: "Azerbaijan, Republic of - VFS Baku",
    value: "Azerbaijan, Republic of; VFS Baku",
  },
  {
    text: "Bahamas (The), the Commonwealth of - Austrian Embassy Washington",
    value: "Bahamas (The), the Commonwealth of; Austrian Embassy Washington",
  },
  {
    text: "Bahrain, Kingdom of - French Embassy Manama",
    value: "Bahrain, Kingdom of; French Embassy Manama",
  },
  {
    text: "Bahrain, Kingdom of - French Embassy Manama",
    value: "Bahrain, Kingdom of; French Embassy Manama",
  },
  {
    text: "Bangladesh, People's Republic of - French Embassy Dhaka",
    value: "Bangladesh, People's Republic of; French Embassy Dhaka",
  },
  {
    text: "Bangladesh, People's Republic of - French Embassy Dhaka",
    value: "Bangladesh, People's Republic of; French Embassy Dhaka",
  },
  {
    text: "Barbados - Austrian Embassy Bogotà",
    value: "Barbados; Austrian Embassy Bogotà",
  },
  {
    text: "Belarus, Repbulic of - Austrian Embassy Moskau",
    value: "Belarus, Repbulic of; Austrian Embassy Moskau",
  },
  {
    text: "Belarus, Repbulic of - German Embassy Minsk",
    value: "Belarus, Repbulic of; German Embassy Minsk",
  },
  {
    text: "Belarus, Repbulic of - VFS Minsk",
    value: "Belarus, Repbulic of; VFS Minsk",
  },
  {
    text: "Belize - Austrian Embassy Mexiko",
    value: "Belize; Austrian Embassy Mexiko",
  },
  {
    text: "Benin, Republic of - Austrian Embassy Abuja",
    value: "Benin, Republic of; Austrian Embassy Abuja",
  },
  {
    text: "Benin, Republic of - French Embassy Cotonou",
    value: "Benin, Republic of; French Embassy Cotonou",
  },
  {
    text: "Bhutan, Kingdom of - Austrian Embassy New Delhi",
    value: "Bhutan, Kingdom of; Austrian Embassy New Delhi",
  },
  {
    text: "Bhutan, Kingdom of - VFS Thimphu",
    value: "Bhutan, Kingdom of; VFS Thimphu",
  },
  {
    text: "Bolivia, Plurinational State of - Austrian Embassy Lima",
    value: "Bolivia, Plurinational State of; Austrian Embassy Lima",
  },
  {
    text: "Bolivia, Plurinational State of - Spanish Embassy La Paz",
    value: "Bolivia, Plurinational State of; Spanish Embassy La Paz",
  },
  {
    text: "Bosnia and Herzegovina - Austrian Embassy Sarajewo",
    value: "Bosnia and Herzegovina; Austrian Embassy Sarajewo",
  },
  {
    text: "Botswana, Republic of - Austrian Embassy Pretoria",
    value: "Botswana, Republic of; Austrian Embassy Pretoria",
  },
  {
    text: "Botswana, Republic of - VFS Gaborone",
    value: "Botswana, Republic of; VFS Gaborone",
  },
  {
    text: "Brazil, Federative Republic of - Austrian Embassy Brasilia",
    value: "Brazil, Federative Republic of; Austrian Embassy Brasilia",
  },
  {
    text: "Brazil, Federative Republic of - Austrian Consulate General Sao Paolo",
    value:
      "Brazil, Federative Republic of; Austrian Consulate General Sao Paolo",
  },
  {
    text: "Brunei Darussalam - Austrian Embassy Kuala Lumpur",
    value: "Brunei Darussalam; Austrian Embassy Kuala Lumpur",
  },
  {
    text: "Burkina Faso - Austrian Embassy Dakar",
    value: "Burkina Faso; Austrian Embassy Dakar",
  },
  {
    text: "Burundi, Republic of - Austrian Embassy Nairobi",
    value: "Burundi, Republic of; Austrian Embassy Nairobi",
  },
  {
    text: "Burundi, Republic of - Belgian Embassy Bujumbura",
    value: "Burundi, Republic of; Belgian Embassy Bujumbura",
  },
  {
    text: "Cabo Verde, Republic of - Austrian Embassy Dakar",
    value: "Cabo Verde, Republic of; Austrian Embassy Dakar",
  },
  {
    text: "Cabo Verde, Republic of - Portuguese Embassy Cabo Verde",
    value: "Cabo Verde, Republic of; Portuguese Embassy Cabo Verde",
  },
  {
    text: "Cambodia, Kingdom of - Austrian Embassy Bangkok",
    value: "Cambodia, Kingdom of; Austrian Embassy Bangkok",
  },
  {
    text: "Cambodia, Kingdom of - German Embassy Phnom Penh",
    value: "Cambodia, Kingdom of; German Embassy Phnom Penh",
  },
  {
    text: "Cameroon, Republic of - Austrian Embassy Abuja",
    value: "Cameroon, Republic of; Austrian Embassy Abuja",
  },
  {
    text: "Cameroon, Republic of - Belgien Embassy Jaunde",
    value: "Cameroon, Republic of; Belgien Embassy Jaunde",
  },
  {
    text: "Canada - Austrian Embassy Ottawa",
    value: "Canada; Austrian Embassy Ottawa",
  },
  {
    text: "Canada - German Consulate General Toronto",
    value: "Canada; German Consulate General Toronto",
  },
  {
    text: "Canada - Swiss Consulate General Vancouver",
    value: "Canada; Swiss Consulate General Vancouver",
  },
  { text: "Canada - VFS Edmonton", value: "Canada; VFS Edmonton" },
  { text: "Canada - VFS Ottawa", value: "Canada; VFS Ottawa" },
  { text: "Canada - VFS Vancouver", value: "Canada; VFS Vancouver" },
  {
    text: "Central African Republic - Austrian Embassy Abuja",
    value: "Central African Republic; Austrian Embassy Abuja",
  },
  {
    text: "Central African Republic - French Embassy Bangui",
    value: "Central African Republic; French Embassy Bangui",
  },
  {
    text: "Chad, Republic of - Austrian Embassy Abuja",
    value: "Chad, Republic of; Austrian Embassy Abuja",
  },
  {
    text: "Chad, Republic of - French Embassy N'Djamena",
    value: "Chad, Republic of; French Embassy N'Djamena",
  },
  {
    text: "Chile, Republic of - Austrian Embassy Santiago",
    value: "Chile, Republic of; Austrian Embassy Santiago",
  },
  {
    text: "China, People's Republic of - Austrian Embassy Beijing",
    value: "China, People's Republic of; Austrian Embassy Beijing",
  },
  {
    text: "China, People's Republic of - Austrian Consulate General Hongkong",
    value: "China, People's Republic of; Austrian Consulate General Hongkong",
  },
  {
    text: "China, People's Republic of - Austrian Consulate General Shanghai",
    value: "China, People's Republic of; Austrian Consulate General Shanghai",
  },
  {
    text: "China, People's Republic of - VFS Beijing",
    value: "China, People's Republic of; VFS Beijing",
  },
  {
    text: "China, People's Republic of - VFS Changsha",
    value: "China, People's Republic of; VFS Changsha",
  },
  {
    text: "China, People's Republic of - VFS Chengdu",
    value: "China, People's Republic of; VFS Chengdu",
  },
  {
    text: "China, People's Republic of - VFS Chongqing",
    value: "China, People's Republic of; VFS Chongqing",
  },
  {
    text: "China, People's Republic of - VFS Fuzhou",
    value: "China, People's Republic of; VFS Fuzhou",
  },
  {
    text: "China, People's Republic of - VFS Guangzhou/Kanton",
    value: "China, People's Republic of; VFS Guangzhou/Kanton",
  },
  {
    text: "China, People's Republic of - VFS Hangzhou",
    value: "China, People's Republic of; VFS Hangzhou",
  },
  {
    text: "China, People's Republic of - VFS Jinan",
    value: "China, People's Republic of; VFS Jinan",
  },
  {
    text: "China, People's Republic of - VFS Kunming",
    value: "China, People's Republic of; VFS Kunming",
  },
  {
    text: "China, People's Republic of - VFS Nanjing",
    value: "China, People's Republic of; VFS Nanjing",
  },
  {
    text: "China, People's Republic of - VFS Shanghai",
    value: "China, People's Republic of; VFS Shanghai",
  },
  {
    text: "China, People's Republic of - VFS Shenyang",
    value: "China, People's Republic of; VFS Shenyang",
  },
  {
    text: "China, People's Republic of - VFS Shenzhen",
    value: "China, People's Republic of; VFS Shenzhen",
  },
  {
    text: "China, People's Republic of - VFS Wuhan",
    value: "China, People's Republic of; VFS Wuhan",
  },
  {
    text: "China, People's Republic of - VFS Xian",
    value: "China, People's Republic of; VFS Xian",
  },
  {
    text: "Colombia - Austrian Embassy Bogotà",
    value: "Colombia; Austrian Embassy Bogotà",
  },
  {
    text: "Comoros, Union of the - Austrian Embassy Nairobi",
    value: "Comoros, Union of the; Austrian Embassy Nairobi",
  },
  {
    text: "Comoros, Union of the - French Embassy Moroni",
    value: "Comoros, Union of the; French Embassy Moroni",
  },
  {
    text: "Congo, Democratic Republic of the - Austrian Embassy Nairobi",
    value: "Congo, Democratic Republic of the; Austrian Embassy Nairobi",
  },
  {
    text: "Congo, Democratic Republic of the - C.E.V. Kinshasa",
    value: "Congo, Democratic Republic of the; C.E.V. Kinshasa",
  },
  {
    text: "Congo, Republic of the - Austrian Embassy Addis Abeba",
    value: "Congo, Republic of the; Austrian Embassy Addis Abeba",
  },
  {
    text: "Congo, Republic of the - French Embassy Brazzaville",
    value: "Congo, Republic of the; French Embassy Brazzaville",
  },
  {
    text: "Costa Rica, Republic of - Austrian Embassy Mexiko",
    value: "Costa Rica, Republic of; Austrian Embassy Mexiko",
  },
  {
    text: "Costa Rica, Republic of - Spanish Embassy San José",
    value: "Costa Rica, Republic of; Spanish Embassy San José",
  },
  {
    text: "Côte d'Ivoire, Republic of - Austrian Embassy Dakar",
    value: "Côte d'Ivoire, Republic of; Austrian Embassy Dakar",
  },
  {
    text: "Côte d'Ivoire, Republic of - Belgian Embassy Abidjan",
    value: "Côte d'Ivoire, Republic of; Belgian Embassy Abidjan",
  },
  {
    text: "Cuba, Republic of - Austrian Embassy Havanna",
    value: "Cuba, Republic of; Austrian Embassy Havanna",
  },
  {
    text: "Cyprus, Republic of - Austrian Embassy Nikosia",
    value: "Cyprus, Republic of; Austrian Embassy Nikosia",
  },
  {
    text: "Cyprus, Republic of - VFS Nicosia",
    value: "Cyprus, Republic of; VFS Nicosia",
  },
  {
    text: "Djibouti, Republic of - Austrian Embassy Addis Abeba",
    value: "Djibouti, Republic of; Austrian Embassy Addis Abeba",
  },
  {
    text: "Djibouti, Republic of - French Embassy Djibouti",
    value: "Djibouti, Republic of; French Embassy Djibouti",
  },
  {
    text: "Dominica, Commonwealth of - Austrian Embassy Havanna",
    value: "Dominica, Commonwealth of; Austrian Embassy Havanna",
  },
  {
    text: "Dominican Republic - Austrian Embassy Havanna",
    value: "Dominican Republic; Austrian Embassy Havanna",
  },
  {
    text: "Dominican Republic - Swiss Embassy Santo Domingo",
    value: "Dominican Republic; Swiss Embassy Santo Domingo",
  },
  {
    text: "Ecuador, Republic of - Austrian Embassy Lima",
    value: "Ecuador, Republic of; Austrian Embassy Lima",
  },
  {
    text: "Ecuador, Republic of - German Embassy Quito",
    value: "Ecuador, Republic of; German Embassy Quito",
  },
  {
    text: "Egypt, Arab Republic of - Austrian Embassy Kairo",
    value: "Egypt, Arab Republic of; Austrian Embassy Kairo",
  },
  {
    text: "Egypt, Arab Republic of - VFS Alexandria",
    value: "Egypt, Arab Republic of; VFS Alexandria",
  },
  {
    text: "Egypt, Arab Republic of - VFS Kairo",
    value: "Egypt, Arab Republic of; VFS Kairo",
  },
  {
    text: "El Salvador, Republic of - Austrian Embassy Mexiko",
    value: "El Salvador, Republic of; Austrian Embassy Mexiko",
  },
  {
    text: "El Salvador, Republic of - Spanish Embassy San Salvador",
    value: "El Salvador, Republic of; Spanish Embassy San Salvador",
  },
  {
    text: "Equatorial Guinea, Republic of - Austrian Embassy Abuja",
    value: "Equatorial Guinea, Republic of; Austrian Embassy Abuja",
  },
  {
    text: "Equatorial Guinea, Republic of - Spanish Embassy Malabo",
    value: "Equatorial Guinea, Republic of; Spanish Embassy Malabo",
  },
  {
    text: "Eritrea, State of - Austrian Embassy Kairo",
    value: "Eritrea, State of; Austrian Embassy Kairo",
  },
  {
    text: "Eswatini, Kingdom of - Austrian Embassy Pretoria",
    value: "Eswatini, Kingdom of; Austrian Embassy Pretoria",
  },
  {
    text: "Ethiopia, Federal Democratic Republic of - VFS Addis Abeba",
    value: "Ethiopia, Federal Democratic Republic of; VFS Addis Abeba",
  },
  {
    text: "Ethiopia, Federal Democratic Republic of - Austrian Embassy Addis Abeba",
    value:
      "Ethiopia, Federal Democratic Republic of; Austrian Embassy Addis Abeba",
  },
  {
    text: "Fiji, Republic of - Austrian Embassy Canberra",
    value: "Fiji, Republic of; Austrian Embassy Canberra",
  },
  {
    text: "Fiji, Republic of - Austrian Embassy Jakarta",
    value: "Fiji, Republic of; Austrian Embassy Jakarta",
  },
  {
    text: "Fiji, Republic of - Austrian Embassy Manila",
    value: "Fiji, Republic of; Austrian Embassy Manila",
  },
  {
    text: "Fiji, Republic of - VFS Suva",
    value: "Fiji, Republic of; VFS Suva",
  },
  {
    text: "Gabon (Gabonese Republic) - Austrian Embassy Abuja",
    value: "Gabon (Gabonese Republic); Austrian Embassy Abuja",
  },
  {
    text: "Gabon (Gabonese Republic) - French Embassy Libreville",
    value: "Gabon (Gabonese Republic); French Embassy Libreville",
  },
  {
    text: "Georgia - Austrian Embassy Tiflis",
    value: "Georgia; Austrian Embassy Tiflis",
  },
  {
    text: "Ghana, Republic of - Austrian Embassy Abuja",
    value: "Ghana, Republic of; Austrian Embassy Abuja",
  },
  {
    text: "Germany, Federal Republic of",
    value: "Germany, Federal Republic of",
  },
  {
    text: "Ghana, Republic of - Dutch Embassy Accra",
    value: "Ghana, Republic of; Dutch Embassy Accra",
  },
  { text: "Greece (Helenic Republic)", value: "Greece (Helenic Republic)" },
  {
    text: "Grenada - Austrian Embassy Havanna",
    value: "Grenada; Austrian Embassy Havanna",
  },
  {
    text: "Guatemala, Republic of - Austrian Embassy Mexiko",
    value: "Guatemala, Republic of; Austrian Embassy Mexiko",
  },
  {
    text: "Guinea, Republic of - Austrian Embassy Dakar",
    value: "Guinea, Republic of; Austrian Embassy Dakar",
  },
  {
    text: "Guinea, Republic of - French Embassy Conakry",
    value: "Guinea, Republic of; French Embassy Conakry",
  },
  {
    text: "Guinea-Bissau, Republic of - Austrian Embassy Dakar",
    value: "Guinea-Bissau, Republic of; Austrian Embassy Dakar",
  },
  {
    text: "Guinea-Bissau, Republic of - Portuguese Embassy Guinea-Bissau",
    value: "Guinea-Bissau, Republic of; Portuguese Embassy Guinea-Bissau",
  },
  {
    text: "Guyana - Austrian Embassy Bogotà",
    value: "Guyana; Austrian Embassy Bogotà",
  },
  {
    text: "Haiti, The Republic of - Austrian Embassy Havanna",
    value: "Haiti, The Republic of; Austrian Embassy Havanna",
  },
  {
    text: "Haiti, The Republic of - French Embassy Port-au-Prince",
    value: "Haiti, The Republic of; French Embassy Port-au-Prince",
  },
  {
    text: "Honduras, Republic of - Austrian Embassy Mexiko",
    value: "Honduras, Republic of; Austrian Embassy Mexiko",
  },
  {
    text: "Honduras, Republic of - Spanish Embassy Tegucigalpa",
    value: "Honduras, Republic of; Spanish Embassy Tegucigalpa",
  },
  {
    text: "India, Republic of - Austrian Embassy New Delhi",
    value: "India, Republic of; Austrian Embassy New Delhi",
  },
  {
    text: "India, Republic of - VFS Ahmedabad",
    value: "India, Republic of; VFS Ahmedabad",
  },
  {
    text: "India, Republic of - VFS Bangalore",
    value: "India, Republic of; VFS Bangalore",
  },
  {
    text: "India, Republic of - VFS Chandigarh",
    value: "India, Republic of; VFS Chandigarh",
  },
  {
    text: "India, Republic of - VFS Chennai",
    value: "India, Republic of; VFS Chennai",
  },
  {
    text: "India, Republic of - VFS Cochin",
    value: "India, Republic of; VFS Cochin",
  },
  {
    text: "India, Republic of - VFS Goa",
    value: "India, Republic of; VFS Goa",
  },
  {
    text: "India, Republic of - VFS Gurgaon",
    value: "India, Republic of; VFS Gurgaon",
  },
  {
    text: "India, Republic of - VFS Hyderabad",
    value: "India, Republic of; VFS Hyderabad",
  },
  {
    text: "India, Republic of - VFS Jaipur",
    value: "India, Republic of; VFS Jaipur",
  },
  {
    text: "India, Republic of - VFS Jalandhar",
    value: "India, Republic of; VFS Jalandhar",
  },
  {
    text: "India, Republic of - VFS Kolkatta",
    value: "India, Republic of; VFS Kolkatta",
  },
  {
    text: "India, Republic of - VFS Lucknow",
    value: "India, Republic of; VFS Lucknow",
  },
  {
    text: "India, Republic of - VFS Mumbai",
    value: "India, Republic of; VFS Mumbai",
  },
  {
    text: "India, Republic of - VFS New Delhi",
    value: "India, Republic of; VFS New Delhi",
  },
  {
    text: "India, Republic of - VFS Puducherry",
    value: "India, Republic of; VFS Puducherry",
  },
  {
    text: "India, Republic of - VFS Pune",
    value: "India, Republic of; VFS Pune",
  },
  {
    text: "Indonesia, Republic of - Austrian Embassy Jakarta",
    value: "Indonesia, Republic of; Austrian Embassy Jakarta",
  },
  {
    text: "Indonesia, Republic of - VFS Bali",
    value: "Indonesia, Republic of; VFS Bali",
  },
  {
    text: "Indonesia, Republic of - VFS Jakarta",
    value: "Indonesia, Republic of; VFS Jakarta",
  },
  {
    text: "Iran, Islamic Republic of - Austrian Embassy Teheran",
    value: "Iran, Islamic Republic of; Austrian Embassy Teheran",
  },
  {
    text: "Iran, Islamic Republic of - VFS Tehran",
    value: "Iran, Islamic Republic of; VFS Tehran",
  },
  {
    text: "Iraq, Republic of - Austrian Embassy Amman",
    value: "Iraq, Republic of; Austrian Embassy Amman",
  },
  {
    text: "Iraq, Republic of - VFS Bagdad",
    value: "Iraq, Republic of; VFS Bagdad",
  },
  {
    text: "Iraq, Republic of - VFS Erbil",
    value: "Iraq, Republic of; VFS Erbil",
  },
  {
    text: "Ireland - Austrian Embassy Dublin",
    value: "Ireland; Austrian Embassy Dublin",
  },
  { text: "Ireland - VFS Dublin", value: "Ireland; VFS Dublin" },
  {
    text: "Israel, State of - Austrian Embassy Tel Aviv",
    value: "Israel, State of; Austrian Embassy Tel Aviv",
  },
  {
    text: "Jamaica - Austrian Embassy Havanna",
    value: "Jamaica; Austrian Embassy Havanna",
  },
  {
    text: "Jamaica - Austrian Embassy Ottawa",
    value: "Jamaica; Austrian Embassy Ottawa",
  },
  {
    text: "Jamaica - Spanish Embassy Kingston",
    value: "Jamaica; Spanish Embassy Kingston",
  },
  { text: "Jamaica - VFS Kingston", value: "Jamaica; VFS Kingston" },
  {
    text: "Japan - Austrian Embassy Tokio",
    value: "Japan; Austrian Embassy Tokio",
  },
  { text: "Japan - VFS Osaka", value: "Japan; VFS Osaka" },
  { text: "Japan - VFS Tokyo", value: "Japan; VFS Tokyo" },
  {
    text: "Jordan, Hashemite Kingdom of - Austrian Embassy Amman",
    value: "Jordan, Hashemite Kingdom of; Austrian Embassy Amman",
  },
  {
    text: "Jordan, Hashemite Kingdom of - VFS Amman",
    value: "Jordan, Hashemite Kingdom of; VFS Amman",
  },
  {
    text: "Kazakhstan, Republic of - Austrian Embassy Astana",
    value: "Kazakhstan, Republic of; Austrian Embassy Astana",
  },
  {
    text: "Kazakhstan, Republic of - Hungarian Consulate General Almaty",
    value: "Kazakhstan, Republic of; Hungarian Consulate General Almaty",
  },
  {
    text: "Kazakhstan, Republic of - VFS Almaty",
    value: "Kazakhstan, Republic of; VFS Almaty",
  },
  {
    text: "Kazakhstan, Republic of - VFS Astana",
    value: "Kazakhstan, Republic of; VFS Astana",
  },
  {
    text: "Kenya, Republic of - Austrian Embassy Nairobi",
    value: "Kenya, Republic of; Austrian Embassy Nairobi",
  },
  {
    text: "Kenya, Republic of - VFS Nairobi",
    value: "Kenya, Republic of; VFS Nairobi",
  },
  {
    text: "Kiribati, Republic of - Austrian Embassy Canberra",
    value: "Kiribati, Republic of; Austrian Embassy Canberra",
  },
  {
    text: "Kiribati, Republic of - Austrian Embassy Jakarta",
    value: "Kiribati, Republic of; Austrian Embassy Jakarta",
  },
  {
    text: "Kiribati, Republic of - Austrian Embassy Manila",
    value: "Kiribati, Republic of; Austrian Embassy Manila",
  },
  {
    text: "Korea, Democratic People's Republic of - Austrian Embassy Beijing",
    value: "Korea, Democratic People's Republic of; Austrian Embassy Beijing",
  },
  {
    text: "Korea, Democratic People's Republic of - Austrian Embassy Seoul",
    value: "Korea, Democratic People's Republic of; Austrian Embassy Seoul",
  },
  {
    text: "Korea, Republic of - Austrian Embassy Seoul",
    value: "Korea, Republic of; Austrian Embassy Seoul",
  },
  {
    text: "Korea, Republic of - VFS Seoul",
    value: "Korea, Republic of; VFS Seoul",
  },
  {
    text: "Kosovo, Republic of - Austrian Embassy Skopje",
    value: "Kosovo, Republic of; Austrian Embassy Skopje",
  },
  {
    text: "Kosovo, Republic of - Swiss Embassy Pristina",
    value: "Kosovo, Republic of; Swiss Embassy Pristina",
  },
  {
    text: "Kuwait, State of - Austrian Embassy Kuwait",
    value: "Kuwait, State of; Austrian Embassy Kuwait",
  },
  {
    text: "Kuwait, State of - VFS Kuwait City",
    value: "Kuwait, State of; VFS Kuwait City",
  },
  {
    text: "Kyrgyzstan (Kyrgyz Republic) - Austrian Embassy Astana",
    value: "Kyrgyzstan (Kyrgyz Republic); Austrian Embassy Astana",
  },
  {
    text: "Kyrgyzstan (Kyrgyz Republic) - VFS Bishkek",
    value: "Kyrgyzstan (Kyrgyz Republic); VFS Bishkek",
  },
  {
    text: "Lao People's Democratic Republic - Austrian Embassy Bangkok",
    value: "Lao People's Democratic Republic; Austrian Embassy Bangkok",
  },
  {
    text: "Lao People's Democratic Republic - German Embassy Vientiane",
    value: "Lao People's Democratic Republic; German Embassy Vientiane",
  },
  {
    text: "Lebanon (Lebanese Republic) - Austrian Embassy Beirut",
    value: "Lebanon (Lebanese Republic); Austrian Embassy Beirut",
  },
  {
    text: "Lebanon (Lebanese Republic) - VFS Beirut",
    value: "Lebanon (Lebanese Republic); VFS Beirut",
  },
  {
    text: "Lesotho Kingdom of - Austrian Embassy Pretoria",
    value: "Lesotho Kingdom of; Austrian Embassy Pretoria",
  },
  {
    text: "Liberia, Republic of - Austrian Embassy Dakar",
    value: "Liberia, Republic of; Austrian Embassy Dakar",
  },
  {
    text: "Libya, State of - Austrian Embassy Tunis",
    value: "Libya, State of; Austrian Embassy Tunis",
  },
  {
    text: "Macau - Austrian Consulate General Hongkong",
    value: "Macau; Austrian Consulate General Hongkong",
  },
  {
    text: "Macau - Portuguese Consulate General Macau",
    value: "Macau; Portuguese Consulate General Macau",
  },
  {
    text: "Madagascar, Republic of - Austrian Embassy Pretoria",
    value: "Madagascar, Republic of; Austrian Embassy Pretoria",
  },
  {
    text: "Madagascar, Republic of - French Embassy Antananarivo",
    value: "Madagascar, Republic of; French Embassy Antananarivo",
  },
  {
    text: "Malawi, Republic of - Austrian Embassy Nairobi",
    value: "Malawi, Republic of; Austrian Embassy Nairobi",
  },
  {
    text: "Malaysia - Austrian Embassy Kuala Lumpur",
    value: "Malaysia; Austrian Embassy Kuala Lumpur",
  },
  { text: "Malaysia - VFS Kuala Lumpur", value: "Malaysia; VFS Kuala Lumpur" },
  {
    text: "Maldives, Republic of - Austrian Embassy New Delhi",
    value: "Maldives, Republic of; Austrian Embassy New Delhi",
  },
  {
    text: "Maldives, Republic of - VFS Male",
    value: "Maldives, Republic of; VFS Male",
  },
  {
    text: "Mali, Republic of - Austrian Embassy Dakar",
    value: "Mali, Republic of; Austrian Embassy Dakar",
  },
  {
    text: "Malta, Republic of - Austrian Embassy Nikosia",
    value: "Malta, Republic of; Austrian Embassy Nikosia",
  },
  {
    text: "Marshall Islands, Republic of the - Austrian Embassy Canberra",
    value: "Marshall Islands, Republic of the; Austrian Embassy Canberra",
  },
  {
    text: "Marshall Islands, Republic of the - Austrian Embassy Jakarta",
    value: "Marshall Islands, Republic of the; Austrian Embassy Jakarta",
  },
  {
    text: "Marshall Islands, Republic of the - Austrian Embassy Manila",
    value: "Marshall Islands, Republic of the; Austrian Embassy Manila",
  },
  {
    text: "Mauritania, Islamic Republic of - Austrian Embassy Rabat",
    value: "Mauritania, Islamic Republic of; Austrian Embassy Rabat",
  },
  {
    text: "Mauritania, Islamic Republic of - Spanish Embassy Nouakchot",
    value: "Mauritania, Islamic Republic of; Spanish Embassy Nouakchot",
  },
  {
    text: "Mauritius, Republic of - Austrian Embassy Pretoria",
    value: "Mauritius, Republic of; Austrian Embassy Pretoria",
  },
  {
    text: "Mauritius, Republic of - French Embassy Port-Louis",
    value: "Mauritius, Republic of; French Embassy Port-Louis",
  },
  {
    text: "Mexico (United Mexican States) - Austrian Embassy Mexiko",
    value: "Mexico (United Mexican States); Austrian Embassy Mexiko",
  },
  {
    text: "Micronesia, Federated States of - Austrian Embassy Canberra",
    value: "Micronesia, Federated States of; Austrian Embassy Canberra",
  },
  {
    text: "Micronesia, Federated States of - Austrian Embassy Jakarta",
    value: "Micronesia, Federated States of; Austrian Embassy Jakarta",
  },
  {
    text: "Micronesia, Federated States of - Austrian Embassy Manila",
    value: "Micronesia, Federated States of; Austrian Embassy Manila",
  },
  {
    text: "Moldova- Republic of - Austian Embassy Bukarest",
    value: "Moldova- Republic of; Austian Embassy Bukarest",
  },
  {
    text: "Moldova- Republic of - Hungarian Embassy Chisinau",
    value: "Moldova- Republic of; Hungarian Embassy Chisinau",
  },
  {
    text: "Mongolia - Austrian Embassy Beijing",
    value: "Mongolia; Austrian Embassy Beijing",
  },
  { text: "Mongolia - VFS Ulaanbator", value: "Mongolia; VFS Ulaanbator" },
  {
    text: "Montenegro - Austrian Embassy Belgrad",
    value: "Montenegro; Austrian Embassy Belgrad",
  },
  {
    text: "Morocco, Kingdom of - Austrian Embassy Rabat",
    value: "Morocco, Kingdom of; Austrian Embassy Rabat",
  },
  {
    text: "Morocco, Kingdom of - VFS Casablanca",
    value: "Morocco, Kingdom of; VFS Casablanca",
  },
  {
    text: "Morocco, Kingdom of - VFS Rabat",
    value: "Morocco, Kingdom of; VFS Rabat",
  },
  {
    text: "Morocco, Kingdom of - VFS Tanger",
    value: "Morocco, Kingdom of; VFS Tanger",
  },
  {
    text: "Mozambique, Republic of - Austrian Embassy Pretoria",
    value: "Mozambique, Republic of; Austrian Embassy Pretoria",
  },
  {
    text: "Mozambique, Republic of - Dutch Embassy Maputo",
    value: "Mozambique, Republic of; Dutch Embassy Maputo",
  },
  {
    text: "Mozambique, Republic of - Portuguese Embassy Maputo",
    value: "Mozambique, Republic of; Portuguese Embassy Maputo",
  },
  {
    text: "Myanmar, Republic of the Union of - Austrian Embassy Bangkok",
    value: "Myanmar, Republic of the Union of; Austrian Embassy Bangkok",
  },
  {
    text: "Myanmar, Republic of the Union of - German Embassy Yangon",
    value: "Myanmar, Republic of the Union of; German Embassy Yangon",
  },
  {
    text: "Namibia, Republic of - Austrian Embassy Pretoria",
    value: "Namibia, Republic of; Austrian Embassy Pretoria",
  },
  {
    text: "Namibia, Republic of - VFS Windhoek",
    value: "Namibia, Republic of; VFS Windhoek",
  },
  {
    text: "Nauru, Republic of - Austrian Embassy Canberra",
    value: "Nauru, Republic of; Austrian Embassy Canberra",
  },
  {
    text: "Nauru, Republic of - Austrian Embassy Jakarta",
    value: "Nauru, Republic of; Austrian Embassy Jakarta",
  },
  {
    text: "Nauru, Republic of - Austrian Embassy Manila",
    value: "Nauru, Republic of; Austrian Embassy Manila",
  },
  {
    text: "Nepal - Austrian Embassy New Delhi",
    value: "Nepal; Austrian Embassy New Delhi",
  },
  { text: "Nepal - VFS Kathmandu", value: "Nepal; VFS Kathmandu" },
  {
    text: "New Zealand - Austrian Embassy Canberra",
    value: "New Zealand; Austrian Embassy Canberra",
  },
  { text: "New Zealand - VFS Auckland", value: "New Zealand; VFS Auckland" },
  {
    text: "Nicaragua, Republic of - Austrian Embassy Mexiko",
    value: "Nicaragua, Republic of; Austrian Embassy Mexiko",
  },
  {
    text: "Nicaragua, Republic of - Spanish Embassy Managua",
    value: "Nicaragua, Republic of; Spanish Embassy Managua",
  },
  {
    text: "Niger, Republic of - Austrian Embassy Algier",
    value: "Niger, Republic of; Austrian Embassy Algier",
  },
  {
    text: "Nigeria, Federal Republic of - Austrian Embassy Abuja",
    value: "Nigeria, Federal Republic of; Austrian Embassy Abuja",
  },
  {
    text: "Nigeria, Federal Republic of - VFS Abuja",
    value: "Nigeria, Federal Republic of; VFS Abuja",
  },
  {
    text: "Nigeria, Federal Republic of - VFS Lagos",
    value: "Nigeria, Federal Republic of; VFS Lagos",
  },
  {
    text: "North Macedonia, Republic of - Austrian Embassy Skopje",
    value: "North Macedonia, Republic of; Austrian Embassy Skopje",
  },
  {
    text: "Oman, Sultanate of - Austrian Embassy Maskat",
    value: "Oman, Sultanate of; Austrian Embassy Maskat",
  },
  {
    text: "Oman, Sultanate of - VFS Maskat",
    value: "Oman, Sultanate of; VFS Maskat",
  },
  {
    text: "Pakistan, Islamic Republic of - Austrian Embassy Islamabad",
    value: "Pakistan, Islamic Republic of; Austrian Embassy Islamabad",
  },
  {
    text: "Pakistan, Islamic Republic of - VFS Islamabad",
    value: "Pakistan, Islamic Republic of; VFS Islamabad",
  },
  {
    text: "Pakistan, Islamic Republic of - VFS Karachi",
    value: "Pakistan, Islamic Republic of; VFS Karachi",
  },
  {
    text: "Pakistan, Islamic Republic of - VFS Lahore",
    value: "Pakistan, Islamic Republic of; VFS Lahore",
  },
  {
    text: "Palau, Republic of - Austrian Embassy Canberra",
    value: "Palau, Republic of; Austrian Embassy Canberra",
  },
  {
    text: "Palau, Republic of - Austrian Embassy Jakarta",
    value: "Palau, Republic of; Austrian Embassy Jakarta",
  },
  {
    text: "Palau, Republic of - Austrian Embassy Manila",
    value: "Palau, Republic of; Austrian Embassy Manila",
  },
  {
    text: "Palestine, State of - Austrian Embassy Tel Aviv",
    value: "Palestine, State of; Austrian Embassy Tel Aviv",
  },
  {
    text: "Palestine, State of - Austrian Representation Ramallah",
    value: "Palestine, State of; Austrian Representation Ramallah",
  },
  {
    text: "Panama, Republic of - Austrian Embassy Bogotà",
    value: "Panama, Republic of; Austrian Embassy Bogotà",
  },
  {
    text: "Panama, Republic of - Spanish Embassy Panama City",
    value: "Panama, Republic of; Spanish Embassy Panama City",
  },
  {
    text: "Papua New Guinea, Independent State of - Austrian Embassy Manila",
    value: "Papua New Guinea, Independent State of; Austrian Embassy Manila",
  },
  {
    text: "Paraguay, Republic of - Austrian Embassy Buenos Aires",
    value: "Paraguay, Republic of; Austrian Embassy Buenos Aires",
  },
  {
    text: "Paraguay, Republic of - Spanish Embassy Asuncion",
    value: "Paraguay, Republic of; Spanish Embassy Asuncion",
  },
  {
    text: "Peru, Republic of - Austrian Embassy Lima",
    value: "Peru, Republic of; Austrian Embassy Lima",
  },
  {
    text: "Philippines, Republic of the - Austrian Embassy Manila",
    value: "Philippines, Republic of the; Austrian Embassy Manila",
  },
  {
    text: "Philippines, Republic of the - VFS Cebu City",
    value: "Philippines, Republic of the; VFS Cebu City",
  },
  {
    text: "Philippines, Republic of the - VFS Manila",
    value: "Philippines, Republic of the; VFS Manila",
  },
  {
    text: "Qatar, State of - German Embassy Doha",
    value: "Qatar, State of; German Embassy Doha",
  },
  {
    text: "Russian Federation - Austrian Embassy Moskau",
    value: "Russian Federation; Austrian Embassy Moskau",
  },
  {
    text: "Russian Federation - VFS Chabarowsk",
    value: "Russian Federation; VFS Chabarowsk",
  },
  {
    text: "Russian Federation - VFS Irkutsk",
    value: "Russian Federation; VFS Irkutsk",
  },
  {
    text: "Russian Federation - VFS Jekaterinenburg",
    value: "Russian Federation; VFS Jekaterinenburg",
  },
  {
    text: "Russian Federation - VFS Kaliningrad",
    value: "Russian Federation; VFS Kaliningrad",
  },
  {
    text: "Russian Federation - VFS Kazan",
    value: "Russian Federation; VFS Kazan",
  },
  {
    text: "Russian Federation - VFS Krasnodar",
    value: "Russian Federation; VFS Krasnodar",
  },
  {
    text: "Russian Federation - VFS Krasnoyarsk",
    value: "Russian Federation; VFS Krasnoyarsk",
  },
  {
    text: "Russian Federation - VFS Moskau",
    value: "Russian Federation; VFS Moskau",
  },
  {
    text: "Russian Federation - VFS Murmansk",
    value: "Russian Federation; VFS Murmansk",
  },
  {
    text: "Russian Federation - VFS Nizhny Novgorod",
    value: "Russian Federation; VFS Nizhny Novgorod",
  },
  {
    text: "Russian Federation - VFS Novosibirsk",
    value: "Russian Federation; VFS Novosibirsk",
  },
  {
    text: "Russian Federation - VFS Omsk",
    value: "Russian Federation; VFS Omsk",
  },
  {
    text: "Russian Federation - VFS Perm",
    value: "Russian Federation; VFS Perm",
  },
  {
    text: "Russian Federation - VFS Rostov am Don",
    value: "Russian Federation; VFS Rostov am Don",
  },
  {
    text: "Russian Federation - VFS Samara",
    value: "Russian Federation; VFS Samara",
  },
  {
    text: "Russian Federation - VFS Saratow",
    value: "Russian Federation; VFS Saratow",
  },
  {
    text: "Russian Federation - VFS St. Petersburg",
    value: "Russian Federation; VFS St. Petersburg",
  },
  {
    text: "Russian Federation - VFS Ufa",
    value: "Russian Federation; VFS Ufa",
  },
  {
    text: "Russian Federation - VFS Wladiwostok",
    value: "Russian Federation; VFS Wladiwostok",
  },
  {
    text: "Rwanda (Rwandese Republic) - Austrian Embassy Nairobi",
    value: "Rwanda (Rwandese Republic); Austrian Embassy Nairobi",
  },
  {
    text: "Saint Kitts and Nevis - Austrian Embassy Havanna",
    value: "Saint Kitts and Nevis; Austrian Embassy Havanna",
  },
  {
    text: "Saint Lucia - Austrian Embassy Havanna",
    value: "Saint Lucia; Austrian Embassy Havanna",
  },
  {
    text: "Saint Lucia - French Embassy Castries",
    value: "Saint Lucia; French Embassy Castries",
  },
  {
    text: "Saint Vincent and the Grenadines - Austrian Embassy Havanna",
    value: "Saint Vincent and the Grenadines; Austrian Embassy Havanna",
  },
  {
    text: "Samoa, Independent State of - Austrian Embassy Canberra",
    value: "Samoa, Independent State of; Austrian Embassy Canberra",
  },
  {
    text: "Samoa, Independent State of - Austrian Embassy Jakarta",
    value: "Samoa, Independent State of; Austrian Embassy Jakarta",
  },
  {
    text: "Samoa, Independent State of - Austrian Embassy Manila",
    value: "Samoa, Independent State of; Austrian Embassy Manila",
  },
  {
    text: "Sao Tome and Principe, Democratic Republic of - Austrian Embassy Abuja",
    value:
      "Sao Tome and Principe, Democratic Republic of; Austrian Embassy Abuja",
  },
  {
    text: "Sao Tome and Principe, Democratic Republic of - Portuguese Embassy São Tomé",
    value:
      "Sao Tome and Principe, Democratic Republic of; Portuguese Embassy São Tomé",
  },
  {
    text: "Saudi Arabia, Kingdom of - Austrian Embassy Riyadh",
    value: "Saudi Arabia, Kingdom of; Austrian Embassy Riyadh",
  },
  {
    text: "Saudi Arabia, Kingdom of - VFS Aramco Dhahran",
    value: "Saudi Arabia, Kingdom of; VFS Aramco Dhahran",
  },
  {
    text: "Saudi Arabia, Kingdom of - VFS Dammam (previously Al Khobar)",
    value: "Saudi Arabia, Kingdom of; VFS Dammam (previously Al Khobar)",
  },
  {
    text: "Saudi Arabia, Kingdom of - VFS Jeddah",
    value: "Saudi Arabia, Kingdom of; VFS Jeddah",
  },
  {
    text: "Saudi Arabia, Kingdom of - VFS Riyadh",
    value: "Saudi Arabia, Kingdom of; VFS Riyadh",
  },
  {
    text: "Senegal, Republic of - Austrian Embassy Dakar",
    value: "Senegal, Republic of; Austrian Embassy Dakar",
  },
  {
    text: "Senegal, Republic of - VFS Dakar",
    value: "Senegal, Republic of; VFS Dakar",
  },
  {
    text: "Serbia, Republic of - Austrian Embassy Belgrad",
    value: "Serbia, Republic of; Austrian Embassy Belgrad",
  },
  {
    text: "Seychelles - Austrian Embassy Nairobi",
    value: "Seychelles; Austrian Embassy Nairobi",
  },
  {
    text: "Sierra Leone, Republic of - Austrian Embassy Dakar",
    value: "Sierra Leone, Republic of; Austrian Embassy Dakar",
  },
  {
    text: "Singapore, Republic of - Austrian Embassy Jakarta",
    value: "Singapore, Republic of; Austrian Embassy Jakarta",
  },
  {
    text: "Singapore, Republic of - French Embassy Singapore",
    value: "Singapore, Republic of; French Embassy Singapore",
  },
  { text: "Slovakia (Slovak Republic)", value: "Slovakia (Slovak Republic)" },
  { text: "Slovenia, Republic of", value: "Slovenia, Republic of" },
  {
    text: "Solomon Islands - Austrian Embassy Canberra",
    value: "Solomon Islands; Austrian Embassy Canberra",
  },
  {
    text: "Solomon Islands - Austrian Embassy Jakarta",
    value: "Solomon Islands; Austrian Embassy Jakarta",
  },
  {
    text: "Solomon Islands - Austrian Embassy Manila",
    value: "Solomon Islands; Austrian Embassy Manila",
  },
  {
    text: "Somalia, Federal Republic of - Austrian Embassy Nairobi",
    value: "Somalia, Federal Republic of; Austrian Embassy Nairobi",
  },
  {
    text: "South Africa, Republic of - Austrian Embassy Pretoria",
    value: "South Africa, Republic of; Austrian Embassy Pretoria",
  },
  {
    text: "South Africa, Republic of - VFS Durban",
    value: "South Africa, Republic of; VFS Durban",
  },
  {
    text: "South Africa, Republic of - VFS Johannesburg",
    value: "South Africa, Republic of; VFS Johannesburg",
  },
  {
    text: "South Africa, Republic of - VFS Kapstadt",
    value: "South Africa, Republic of; VFS Kapstadt",
  },
  {
    text: "South Africa, Republic of - VFS Pretoria",
    value: "South Africa, Republic of; VFS Pretoria",
  },
  {
    text: "South Sudan, Republic of - Austrian Embassy Addis Abeba",
    value: "South Sudan, Republic of; Austrian Embassy Addis Abeba",
  },
  {
    text: "Sri Lanka, Democratic Socialist Republic of - Austrian Embassy New Delhi",
    value:
      "Sri Lanka, Democratic Socialist Republic of; Austrian Embassy New Delhi",
  },
  {
    text: "Sudan, Republic of the - Austrian Embassy Cairo",
    value: "Sudan, Republic of the; Austrian Embassy Cairo",
  },
  {
    text: "Suriname, Republic of - Austrian Embassy Brasilia",
    value: "Suriname, Republic of; Austrian Embassy Brasilia",
  },
  {
    text: "Suriname, Republic of - Dutch Embassy Paramaribo",
    value: "Suriname, Republic of; Dutch Embassy Paramaribo",
  },
  {
    text: "Syrian Arab Republic - Austrian Embassy Damaskus (currently located in Beirut)",
    value:
      "Syrian Arab Republic; Austrian Embassy Damaskus (currently located in Beirut)",
  },
  {
    text: "Taiwan - Austrian Office Taipei",
    value: "Taiwan; Austrian Office Taipei",
  },
  {
    text: "Tajikistan, Republic of - Austrian Embassy Astana",
    value: "Tajikistan, Republic of; Austrian Embassy Astana",
  },
  {
    text: "Tajikistan, Republic of - German Embassy Dushanbe",
    value: "Tajikistan, Republic of; German Embassy Dushanbe",
  },
  {
    text: "Tajikistan, Republic of - VFS Dushanbe",
    value: "Tajikistan, Republic of; VFS Dushanbe",
  },
  {
    text: "Tanzania, United Republic of - Austrian Embassy Nairobi",
    value: "Tanzania, United Republic of; Austrian Embassy Nairobi",
  },
  {
    text: "Tanzania, United Republic of - Belgian Embassy Dar es Salaam",
    value: "Tanzania, United Republic of; Belgian Embassy Dar es Salaam",
  },
  {
    text: "Thailand, Kingdom of - Austrian Embassy Bangkok",
    value: "Thailand, Kingdom of; Austrian Embassy Bangkok",
  },
  {
    text: "Thailand, Kingdom of - VFS Bangkok",
    value: "Thailand, Kingdom of; VFS Bangkok",
  },
  {
    text: "Timor-Leste, Democratic Republic of - Austrian Embassy Jakarta",
    value: "Timor-Leste, Democratic Republic of; Austrian Embassy Jakarta",
  },
  {
    text: "Timor-Leste, Democratic Republic of - Portuguese Embassy Díli",
    value: "Timor-Leste, Democratic Republic of; Portuguese Embassy Díli",
  },
  {
    text: "Togo (Togolese Republic) - Austrian Embassy Abuja",
    value: "Togo (Togolese Republic); Austrian Embassy Abuja",
  },
  {
    text: "Togo (Togolese Republic) - French Embassy Lomé",
    value: "Togo (Togolese Republic); French Embassy Lomé",
  },
  {
    text: "Tonga, Kingdom of - Austrian Embassy Canberra",
    value: "Tonga, Kingdom of; Austrian Embassy Canberra",
  },
  {
    text: "Tonga, Kingdom of - Austrian Embassy Jakarta",
    value: "Tonga, Kingdom of; Austrian Embassy Jakarta",
  },
  {
    text: "Tonga, Kingdom of - Austrian Embassy Manila",
    value: "Tonga, Kingdom of; Austrian Embassy Manila",
  },
  {
    text: "Trinidad and Tobago, Republic of - Austrian Embassy Bogotà",
    value: "Trinidad and Tobago, Republic of; Austrian Embassy Bogotà",
  },
  {
    text: "Tunisia, Republic of - Austrian Embassy Tunis",
    value: "Tunisia, Republic of; Austrian Embassy Tunis",
  },
  {
    text: "Tunisia, Republic of - VFS Tunis",
    value: "Tunisia, Republic of; VFS Tunis",
  },
  {
    text: "Türkiye, Republic of - Austrian Consulate General Istanbul",
    value: "Türkiye, Republic of; Austrian Consulate General Istanbul",
  },
  {
    text: "Türkiye, Republic of - VFS Ankara",
    value: "Türkiye, Republic of; VFS Ankara",
  },
  {
    text: "Türkiye, Republic of - VFS Antalya",
    value: "Türkiye, Republic of; VFS Antalya",
  },
  {
    text: "Türkiye, Republic of - VFS Bursa",
    value: "Türkiye, Republic of; VFS Bursa",
  },
  {
    text: "Türkiye, Republic of - VFS Edirne",
    value: "Türkiye, Republic of; VFS Edirne",
  },
  {
    text: "Türkiye, Republic of - VFS Gaziantep",
    value: "Türkiye, Republic of; VFS Gaziantep",
  },
  {
    text: "Türkiye, Republic of - VFS Istanbul Altunizade",
    value: "Türkiye, Republic of; VFS Istanbul Altunizade",
  },
  {
    text: "Türkiye, Republic of - VFS Istanbul Beyoglu",
    value: "Türkiye, Republic of; VFS Istanbul Beyoglu",
  },
  {
    text: "Türkiye, Republic of - VFS Izmir",
    value: "Türkiye, Republic of; VFS Izmir",
  },
  {
    text: "Türkiye, Republic of - VFS Trabzon",
    value: "Türkiye, Republic of; VFS Trabzon",
  },
  {
    text: "Turkmenistan - Austrian Embassy Baku",
    value: "Turkmenistan; Austrian Embassy Baku",
  },
  {
    text: "Turkmenistan - German Embassy Ashgabat",
    value: "Turkmenistan; German Embassy Ashgabat",
  },
  {
    text: "Tuvalu - Austrian Embassy Canberra",
    value: "Tuvalu; Austrian Embassy Canberra",
  },
  {
    text: "Tuvalu - Austrian Embassy Jakarta",
    value: "Tuvalu; Austrian Embassy Jakarta",
  },
  {
    text: "Tuvalu - Austrian Embassy Manila",
    value: "Tuvalu; Austrian Embassy Manila",
  },
  {
    text: "Uganda, Republic of - Austrian Embassy Addis Abeba",
    value: "Uganda, Republic of; Austrian Embassy Addis Abeba",
  },
  {
    text: "United Arab Emirates - Austrian Embassy Abu Dhabi",
    value: "United Arab Emirates; Austrian Embassy Abu Dhabi",
  },
  {
    text: "United Arab Emirates - VFS Abu Dhabi",
    value: "United Arab Emirates; VFS Abu Dhabi",
  },
  {
    text: "United Arab Emirates - VFS Dubai",
    value: "United Arab Emirates; VFS Dubai",
  },
  {
    text: "United Kingdom, of Great Britain and Northern Ireland - Austrian Embassy London",
    value:
      "United Kingdom, of Great Britain and Northern Ireland; Austrian Embassy London",
  },
  {
    text: "United Kingdom, of Great Britain and Northern Ireland - VFS Edinburgh",
    value:
      "United Kingdom, of Great Britain and Northern Ireland; VFS Edinburgh",
  },
  {
    text: "United Kingdom, of Great Britain and Northern Ireland - VFS London",
    value: "United Kingdom, of Great Britain and Northern Ireland; VFS London",
  },
  {
    text: "United Kingdom, of Great Britain and Northern Ireland - VFS Manchester",
    value:
      "United Kingdom, of Great Britain and Northern Ireland; VFS Manchester",
  },
  {
    text: "United States, of America - Austrian Embassy Washington",
    value: "United States, of America; Austrian Embassy Washington",
  },
  {
    text: "United States, of America - Austrian Consulate General Los Angeles",
    value: "United States, of America; Austrian Consulate General Los Angeles",
  },
  {
    text: "United States, of America - Austrian Consulate General New York",
    value: "United States, of America; Austrian Consulate General New York",
  },
  {
    text: "United States, of America - VFS Chicago",
    value: "United States, of America; VFS Chicago",
  },
  {
    text: "United States, of America - VFS Houston",
    value: "United States, of America; VFS Houston",
  },
  {
    text: "United States, of America - VFS Los Angeles",
    value: "United States, of America; VFS Los Angeles",
  },
  {
    text: "United States, of America - VFS Miami",
    value: "United States, of America; VFS Miami",
  },
  {
    text: "United States, of America - VFS New York",
    value: "United States, of America; VFS New York",
  },
  {
    text: "United States, of America - VFS San Francisco",
    value: "United States, of America; VFS San Francisco",
  },
  {
    text: "United States, of America - VFS Washington DC",
    value: "United States, of America; VFS Washington DC",
  },
  {
    text: "Uruguay, Eastern Republic of - Austrian Embassy Buenos Aires",
    value: "Uruguay, Eastern Republic of; Austrian Embassy Buenos Aires",
  },
  {
    text: "Uruguay, Eastern Republic of - Spanish Embassy Montevideo",
    value: "Uruguay, Eastern Republic of; Spanish Embassy Montevideo",
  },
  {
    text: "Uzbekistan, Republic of - Austrian Embassy Baku",
    value: "Uzbekistan, Republic of; Austrian Embassy Baku",
  },
  {
    text: "Uzbekistan, Republic of - Hungarian Embassy Tashkent",
    value: "Uzbekistan, Republic of; Hungarian Embassy Tashkent",
  },
  {
    text: "Uzbekistan, Republic of - VFS Tashkent",
    value: "Uzbekistan, Republic of; VFS Tashkent",
  },
  {
    text: "Vanuatu, Republic of - Austrian Embassy Canberra",
    value: "Vanuatu, Republic of; Austrian Embassy Canberra",
  },
  {
    text: "Vanuatu, Republic of - Austrian Embassy Jakarta",
    value: "Vanuatu, Republic of; Austrian Embassy Jakarta",
  },
  {
    text: "Vanuatu, Republic of - Austrian Embassy Manila",
    value: "Vanuatu, Republic of; Austrian Embassy Manila",
  },
  {
    text: "Vanuatu, Republic of - French Embassy Port-Vila",
    value: "Vanuatu, Republic of; French Embassy Port-Vila",
  },
  {
    text: "Venezuela, Bolivarian Republik of - Austrian Embassy Bogotà",
    value: "Venezuela, Bolivarian Republik of; Austrian Embassy Bogotà",
  },
  {
    text: "Viet Nam, Socialist Republic of - Austrian Embassy Hanoi",
    value: "Viet Nam, Socialist Republic of; Austrian Embassy Hanoi",
  },
  {
    text: "Viet Nam, Socialist Republic of - VFS Hanoi",
    value: "Viet Nam, Socialist Republic of; VFS Hanoi",
  },
  {
    text: "Viet Nam, Socialist Republic of - VFS Ho Chi Minh City",
    value: "Viet Nam, Socialist Republic of; VFS Ho Chi Minh City",
  },
  {
    text: "Yemen, Republic of - Austrian Embassy Maskat",
    value: "Yemen, Republic of; Austrian Embassy Maskat",
  },
  {
    text: "Zambia, Republic of - Austrian Embassy Nairobi",
    value: "Zambia, Republic of; Austrian Embassy Nairobi",
  },
  {
    text: "Zambia, Republic of - German Embassy Lusaka",
    value: "Zambia, Republic of; German Embassy Lusaka",
  },
  {
    text: "Zimbabwe, Republic of - Austrian Embassy Pretoria",
    value: "Zimbabwe, Republic of; Austrian Embassy Pretoria",
  },
  {
    text: "Zimbabwe, Republic of - VFS Harare",
    value: "Zimbabwe, Republic of; VFS Harare",
  },
];

export default visaOfficeValues;
